module.exports = __webpack_public_path__ + "static/media/blog_59.c88b4000.webp";